import React from 'react';
import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import { isReleased } from '@utils/globals';
import Countdown from '@components/Countdown';
import STRINGS from '@utils/strings';

const Container = styled.div(({ theme, isReleased }) => {
    let releasedStyle = isReleased ? { textTransform: 'uppercase', padding: theme.spacing.xs } : { padding: theme.spacing.xxs };

    return {
        ...theme.typography.h3,
        width: '100%',
        color: theme.colors.common.grey,
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: theme.colors.common.white,
        ...releasedStyle
    };
});

function Ribbon() {
    const theme = useTheme();

    return (
        <Container isReleased={isReleased()}>
            {isReleased() ? STRINGS.ribbon : <Countdown />}
        </Container>
    );
}

export default Ribbon;
